import React, { forwardRef } from "react"
import withStyles from "react-jss"
import { Card, JumpingDots } from "."
import colors from "../data/colors"
import { HeadphoneJack } from "../assets/images"
import { BREAKPOINT } from "../data/uniqueValues"

const styles = {
  heading: {
    lineHeight: "normal",
    maxWidth: "650px",
    color: colors.black,
    padding: "0 1rem",
    textAlign: "center",
    fontSize: "calc(22px + (32 - 22) * ((100vw - 300px) / (1600 - 300)))",
    whiteSpace: "nowrap",
  },
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    margin: "0 0.5rem",
    boxSizing: "border-box",
    marginLeft: "-1rem",
    [`@media only screen and (max-width: ${BREAKPOINT}px)`]: {
      marginLeft: "0.5rem",
    },
  },
  jack: {
    width: "10vw",
    minWidth: "60px",
    maxWidth: "130px",
    [`@media only screen and (max-width: ${BREAKPOINT}px)`]: {
      display: "none",
    },
  },
}

const Loading = ({ classes, headingRef }, ref) => {
  return (
    <Card
      ref={ref}
      palette={{
        primary: colors.yellow,
        secondary: colors.white,
      }}
      loading={true}>
      <div className={classes.container}>
        <img
          className={classes.jack}
          src={HeadphoneJack}
          alt="Headphone jack."
          ref={headingRef}
        />
        <h3 className={classes.heading}>
          Finding your perfect headset <JumpingDots />
        </h3>
      </div>
    </Card>
  )
}

export default withStyles(styles)(forwardRef(Loading))
